import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const UpperCase = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4284 19.8889C13.357 19.8889 11.5334 17.9501 11.5334 14.5524V4.11134L13.0925 4.11134V14.3989C13.0925 16.8559 14.4704 18.4039 16.4284 18.4039C18.4056 18.4039 19.6514 16.8559 19.6514 14.3988V4.11133L21.3425 4.11134V14.5524C21.3425 17.9501 19.5189 19.8889 16.4284 19.8889ZM7.81372 16.1643V11.3276H9.07082V19.5095H7.81372V18.1245H7.72849C7.53673 18.54 7.23844 18.8933 6.83361 19.1845C6.42878 19.4722 5.91741 19.616 5.29952 19.616C4.78815 19.616 4.33361 19.5041 3.93588 19.2804C3.53815 19.0531 3.22565 18.7122 2.99838 18.2577C2.77111 17.7996 2.65747 17.2225 2.65747 16.5265V11.3276H3.91457V16.4413C3.91457 17.0379 4.08148 17.5137 4.41528 17.8688C4.75264 18.2239 5.18233 18.4015 5.70435 18.4015C6.01685 18.4015 6.33467 18.3216 6.65783 18.1618C6.98453 18.002 7.25797 17.757 7.47814 17.4267C7.70186 17.0965 7.81372 16.6757 7.81372 16.1643ZM7.93838 7.55942C8.13364 7.75468 8.45022 7.75469 8.64549 7.55943C8.84075 7.36417 8.84075 7.04758 8.64549 6.85232L6.16739 4.37417C6.07362 4.2804 5.94645 4.22772 5.81384 4.22772C5.68123 4.22772 5.55405 4.2804 5.46028 4.37417L2.98213 6.85232C2.78687 7.04758 2.78687 7.36416 2.98213 7.55942C3.17739 7.75469 3.49398 7.75469 3.68924 7.55942L5.31383 5.93483L5.31383 10.5202C5.31383 10.7963 5.53769 11.0202 5.81383 11.0202C6.08998 11.0202 6.31383 10.7963 6.31383 10.5202L6.31383 5.93484L7.93838 7.55942Z"
        fill={color}
      />
    </svg>
  )
})

export default UpperCase
